import { connect } from 'react-redux';

import { jobTypeListByCategorySelector, popularJobTypesSelector } from 'modules/job-types/duck';
import { RootState } from 'store/types';

import CategoryPage from './Category';
import type { Category } from './Category';
import { blogPostsSelector } from 'modules/marketing-pages/duck';

const mapStateToProps = (state: RootState) => ({
  category: state.jobCategories.detail as Category,
  popular: popularJobTypesSelector(state),
  // TODO: Remove if we do a full transition away from the existing internal blog endpoints
  posts: blogPostsSelector(state),
  verticals: jobTypeListByCategorySelector(state),
});

export type ReduxProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(CategoryPage);
